import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fees-master',
  templateUrl: './fees-master.component.html',
  styleUrls: ['./fees-master.component.scss']
})
export class FeesMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
